import { Controller } from 'stimulus';

class ReadMoreController extends Controller {
  onTogglerClick({ currentTarget }) {
    const isExpanded = currentTarget.getAttribute('aria-expanded') === 'true';

    this.toggleButtonText(currentTarget, isExpanded);
  }

  // eslint-disable-next-line class-methods-use-this
  toggleButtonText(toggler, state) {
    const { expandedText, collapsedText } = toggler.dataset;

    toggler.innerText = state ? collapsedText : expandedText;
  }
}

export default ReadMoreController;
